module.exports = __webpack_public_path__ + "media/images/receipt-e6e4445298a9d33d33828be983286c0a.svg";